/**
 * 实例学习统计抽屉（旧 components/StatsDrawer.vue）：只显示当前实例的统计，不沿用上一个实例的数据
 */
import { useEffect } from 'react'
import { App, Card, Col, Drawer, Row, Spin, Statistic } from 'antd'
import { learningDays } from './constants'
import { useInstanceStats } from './hooks'
import styles from './UserInstances.module.css'

interface StatsDrawerProps {
  // 为 null 时抽屉关闭
  instanceId: number | null
  onClose: () => void
}

export function StatsDrawer({ instanceId, onClose }: Readonly<StatsDrawerProps>) {
  const { message } = App.useApp()
  const { data: stats, isLoading, isError } = useInstanceStats(instanceId)

  useEffect(() => {
    if (isError) message.error('获取统计信息失败')
  }, [isError, message])

  return (
    <Drawer open={instanceId !== null} title="学习统计" size={600} footer={null} onClose={onClose}>
      <Spin spinning={isLoading}>
        {stats && (
          <>
            <Card>
              <Statistic title="学习进度" value={stats.progressPercentage} precision={2} suffix="%" />
            </Card>
            <Row gutter={16} className={styles.statsRow}>
              <Col span={12}>
                <Statistic
                  title="已完成篇章"
                  value={stats.completedEpisodes}
                  suffix={`/ ${stats.totalEpisodesGenerated}`}
                />
              </Col>
              <Col span={12}>
                <Statistic title="平均阅读时间" value={stats.avgReadingTimeSeconds} suffix="秒" />
              </Col>
            </Row>
            <Row gutter={16} className={styles.statsRow}>
              <Col span={12}>
                <Statistic title="总词数" value={stats.totalWordCount} />
              </Col>
              <Col span={12}>
                <Statistic title="词汇覆盖率" value={stats.coverageRate} precision={2} suffix="%" />
              </Col>
            </Row>
            <Row gutter={16} className={styles.statsRow}>
              <Col span={12}>
                <Statistic title="总生词数" value={stats.totalUnknownWords} />
              </Col>
              <Col span={12}>
                <Statistic title="学习天数" value={learningDays(stats)} />
              </Col>
            </Row>
          </>
        )}
      </Spin>
    </Drawer>
  )
}
